module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-container",
    attrs: {
      "id": "game-menu"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ol', {
    staticClass: "options"
  }, [(!_vm.$store.state.isGameStarted) ? _c('li', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.initGame
    }
  }, [_vm._v("Play")])]) : _vm._e(), _vm._v(" "), (_vm.isPaused) ? _c('li', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.resumeGame
    }
  }, [_vm._v("Resume")])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.isPaused) ? _c('li', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.quitGame
    }
  }, [_vm._v("Quit Game")])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('li', [_vm._v("Leave a Comment")])]), _vm._v(" "), _c('vue-disqus', {
    attrs: {
      "shortname": "iamkumaran",
      "url": "http://iamkumaran.github.io/scramble-a-vue-js-game/",
      "identifier": "Scramble - A Vue.js Game Page"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-logo"
  }, [_c('a', {
    attrs: {
      "href": "http://iamkumaran.github.io/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://iamkumaran.github.io/img/logo.png",
      "title": "Back To My Github Page"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/scramble-logo.png"),
      "title": "logo",
      "alt": "logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/iamkumaran/scramble-a-vue-js-game",
      "target": "_blank"
    }
  }, [_vm._v("Github")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "addthis_inline_share_toolbox"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "http://iamkumaran.github.io/scramble-a-vue-js-game/",
      "data-layout": "standard",
      "data-action": "like",
      "data-show-faces": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dc60281","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameMenu.vue
// module id = 23
// module chunks = 0